import api from '../library/axios';

export default {
  dashboardAnalytic({
    workspace_id, date_type, start_date, end_date,
  }) {
    return api({
      method: 'get',
      url: `/api/analytics/dashboard/${workspace_id}`,
      params: {
        date_type,
        start_date,
        end_date,
      },
    });
  },
  workspaceStats({
    workspace_id,
  }) {
    return api({
      method: 'get',
      url: `/api/analytics/stats/${workspace_id}`,
    });
  },
  chatbotAnalytics({
    workspace_id,
  }) {
    return api({
      method: 'get',
      url: `/api/analytic-dashboard/${workspace_id}`,
    });
  },
  channelSummary({
    workspace_id,
    start_date,
    end_date,
  }) {
    return api({
      method: 'get',
      url: `/api/analytics/session/${workspace_id}/summary`,
      params: {
        start_date,
        end_date,
      },
    });
  },
  broadcastSummary({
    workspace_id,
    start_date,
    end_date,
  }) {
    return api({
      method: 'get',
      url: `/api/analytics/broadcast/${workspace_id}/summary`,
      params: {
        start_date,
        end_date,
      },
    });
  },
  broadcastChart({
    workspace_id,
    start_date,
    end_date,
  }) {
    return api({
      method: 'get',
      url: `/api/analytics/broadcast/${workspace_id}/chart`,
      params: {
        start_date,
        end_date,
      },
    });
  },
  callDuration({
    workspace_id,
    start_date,
    end_date,
  }) {
    return api({
      method: 'get',
      url: `/api/analytics/${workspace_id}/call-duration`,
      params: {
        start_date,
        end_date,
      },
    });
  },
  callChart({
    workspace_id,
    start_date,
    end_date,
  }) {
    return api({
      method: 'get',
      url: `/api/analytics/${workspace_id}/call-charts`,
      params: {
        start_date,
        end_date,
      },
    });
  },
  resolvedConversationChart({
    workspace_id,
    start_date,
    end_date,
    display_as,
  }) {
    return api({
      method: 'get',
      url: `/api/analytics/${workspace_id}/resolved-conversations`,
      params: {
        start_date,
        end_date,
        display_as,
      },
    });
  },
  templateMessageStatus({
    workspace_id,
    start_date,
    end_date,
    // display_as,
  }) {
    return api({
      method: 'get',
      url: `/api/analytics/${workspace_id}/template-message-status`,
      params: {
        start_date,
        end_date,
        // display_as,
      },
    });
  },
  channelChart({
    workspace_id,
    start_date,
    end_date,
  }) {
    return api({
      method: 'get',
      url: `/api/analytics/session/${workspace_id}/chart`,
      params: {
        start_date,
        end_date,
      },
    });
  },
  resolvedConversationTime({
    workspace_id,
    start_date,
    end_date,
    time_type,
  }) {
    return api({
      method: 'get',
      url: `/api/analytics/${workspace_id}/resolved-conversations-time`,
      params: {
        start_date,
        end_date,
        time_type,
      },
    });
  },
  analyticInOutMessages({ workspace_id, start_date, end_date }) {
    return api({
      method: 'get',
      url: `/api/analytics/${workspace_id}/in-out-messages`,
      params: {
        start_date,
        end_date,
      },
    });
  },
  analyticInOutCalls({ workspace_id, start_date, end_date }) {
    return api({
      method: 'get',
      url: `/api/analytics/${workspace_id}/in-out-calls`,
      params: {
        start_date,
        end_date,
      },
    });
  },
  statusConversations({ workspace_id, start_date, end_date }) {
    return api({
      method: 'get',
      url: `/api/analytics/${workspace_id}/status-conversations`,
      params: {
        start_date,
        end_date,
      },
    });
  },
  statusLeads({ workspace_id, start_date, end_date }) {
    return api({
      method: 'get',
      url: `/api/analytics/${workspace_id}/status-leads`,
      params: {
        start_date,
        end_date,
      },
    });
  },
  callStatusPercentage({
    workspace_id,
    start_date,
    end_date,
  }) {
    return api({
      method: 'get',
      url: `/api/analytics/${workspace_id}/status-calls`,
      params: {
        start_date,
        end_date,
      },
    });
  },
  statusSlaCall({
    workspace_id,
    start_date,
    end_date,
  }) {
    return api({
      method: 'get',
      url: `/api/analytics/${workspace_id}/sla-call`,
      params: {
        start_date,
        end_date,
      },
    });
  },
  statusSlaTicket({
    workspace_id,
    start_date,
    end_date,
  }) {
    return api({
      method: 'get',
      url: `/api/analytics/${workspace_id}/sla-ticket`,
      params: {
        start_date,
        end_date,
      },
    });
  },
  getLatestSlaCall({
    workspace_id,
    conversation_id,
  }) {
    return api({
      method: 'get',
      url: `/api/analytics/${workspace_id}/${conversation_id}/sla-call/latest`,
    });
  },
  summaryChatbotKeywords({
    workspace_id,
    start_date,
    end_date,
    search_by,
    search_keyword,
  }) {
    return api({
      method: 'get',
      url: `/api/analytics/${workspace_id}/summary-chatbot-keywords`,
      params: {
        start_date,
        end_date,
        search_by,
        search_keyword,
      },
    });
  },
  summaryChatbotTitleKeywords({
    workspace_id,
    start_date,
    end_date,
  }) {
    return api({
      method: 'get',
      url: `/api/analytics/${workspace_id}/summary-title-chatbot-keywords`,
      params: {
        start_date,
        end_date,
      },
    });
  },
  chatbotKeywordCharts({
    workspace_id,
    start_date,
    end_date,
    search_by,
    search_keyword,
  }) {
    return api({
      method: 'get',
      url: `/api/analytics/${workspace_id}/chatbot-keyword-charts`,
      params: {
        start_date,
        end_date,
        search_by,
        search_keyword,
      },
    });
  },
  chatbotKeywordChannels({
    workspace_id,
    start_date,
    end_date,
  }) {
    return api({
      method: 'get',
      url: `/api/analytics/${workspace_id}/chatbot-keyword-channels`,
      params: {
        start_date,
        end_date,
      },
    });
  },
};
